import {
    useState,
    forwardRef,
    useImperativeHandle,
} from "react"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { format } from "date-fns"

import TextInput from "../TextInput"

const DateSelector = forwardRef(({ title, data, readOnly }, ref) => {

    const dateFormat = getDateFormat()

    const isMasked = data === "XX/XX/XXXX" && readOnly

    const [date, setDate] = useState(data ? parseMMDDYYYY(data) : null)

    const [error, setError] = useState(false)

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            const isValid = date instanceof Date && !isNaN(date)
            setError(!isValid)

            return {
                isValid,
                value: isValid ? format(date, "MM/dd/yyyy") : "",
            }
        },
    }))

    return (
        <div className="py-4">
            <label className="block text-sm font-medium text-gray-700">{title}</label>
            {
                isMasked && (
                    <TextInput
                        data={data}
                        disabled={readOnly}
                    />
                )
            }
            {
                !isMasked && (
                    <DatePicker
                        selected={date}
                        onChange={(d) => setDate(d)}
                        disabled={readOnly}
                        dateFormat={dateFormat}
                        placeholderText={dateFormat}
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        className={`mt-1 mb-2 pr-10 pl-3 py-2 block w-full rounded-md  shadow-sm focus:ring-blue-500 focus:border-blue-500 border border-gray-300 ${error ? "border-red-500" : "border-gray-300"}`}
                    />
                )
            }
            {error && (
                <p className="mt-1 text-sm text-red-600">
                    {title} is invalid
                </p>
            )}
        </div>
    )
})

export default DateSelector


function getDateFormat(date = new Date()) {
    const parts = new Intl.DateTimeFormat(undefined, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        numberingSystem: 'latn'
    }).formatToParts(date);

    const order = parts
        .filter(p => ['day', 'month', 'year'].includes(p.type))
        .map(p => p.type);

    const format = order
        .map(type => {
            if (type === 'day') return 'dd';
            if (type === 'month') return 'MM';
            if (type === 'year') return 'yyyy';
        })
        .join('/')

    return format
}

function parseMMDDYYYY(dateStr) {
    const [month, day, year] = dateStr.split('/').map(Number);
    return new Date(year, month - 1, day); // month is 0-based
}
